import { Icon, IconType, Link } from '@dagens/carrot';
import { ForwardedRef, forwardRef } from 'react';

type Props = {
  text?: string;
  icon?: IconType;
  to?: string;
  focused: boolean;
};

const Component = (
  { text, icon, to, focused }: Props,
  ref: ForwardedRef<HTMLAnchorElement>
) => {
  if (!to) {
    return null;
  }

  return (
    <Link
      ref={ref}
      size="regular"
      variant="borderless"
      alignment="left"
      focused={focused}
      to={to}
    >
      {icon && <Icon icon={icon} size="medium" />}
      {text}
    </Link>
  );
};

export const CommandPaletteResult = forwardRef(Component);
